import {
  type TableFilter,
  isBooleanTableFilter,
  isObjectTableFilter,
  isSelectTableFilter,
} from '@ipfabric/utils';
import {
  TABLE_COLUMN_MIN_FILTERED_WIDTH,
  TABLE_COLUMN_MIN_FILTERED_WIDTH_SELECT,
} from 'components/Table/tableSettings';

export const getFilteredColumnMinWidth = (filter?: TableFilter): number =>
  isObjectTableFilter(filter) ||
  isSelectTableFilter(filter) ||
  isBooleanTableFilter(filter)
    ? TABLE_COLUMN_MIN_FILTERED_WIDTH_SELECT
    : TABLE_COLUMN_MIN_FILTERED_WIDTH;
